// Virtual resource that links other resources. `type` is set by firebase.createMultiResource,
// not by the form. See docs/features/multiresources.md.
export const _multiResourceClass = {
  displayName: { type: 'string', title: 'Nimi' },
  // Options come from config/resourcecategories at runtime (ResourcesContainer), like a
  // regular resource's category; stored lower-cased the same way.
  category: { type: 'string', title: 'Kategoria', oneOf: [] },
  sport: { type: 'string', title: 'Laji' },
  // Venue doc id (customers/{cid}/venues); options filled at runtime.
  venueid: { type: 'string', title: 'Paikka', oneOf: [] },
  description: { type: 'string', title: 'Kuvaus' },
  order: { type: 'number', title: 'Järjestys' },
  resources: {
    type: 'array',
    title: 'Linkitetyt resurssit',
    items: {
      type: 'string',
      oneOf: [],
    },
    uniqueItems: true,
    minItems: 1,
  },
}

export const _multiResourceRequired = ['displayName', 'resources']

export const _multiResourceUISchema = {
  resources: {
    'ui:widget': 'checkboxes',
  },
}
